import { ICourse, ICourse2 } from '@et/types/Courses'
import DefaultTheme from '@styles/themes/defaultTheme'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'
// TODO: reg price link and sale price link so we only have to change one item
const slug = 'watercolor-florals-in-procreate'
const title = 'Watercolor Florals in Procreate'
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.LIGHT,
  title,
  slug,
  videoId: `62x58o1ue1`,
  keywords: [
    'watercolor', 'procreate', 'lettering', 'hand lettering', 'procreate brushes', 'watercolor flowers', 'watercolor texture', 'ipad', 'procreate tutorial lettering', 'watercolor paper texture', 'tutorial', 'tutorials', 'how to', 'procreate watercolor brushes', 'procreate tutorial watercolor', 'in depth procreate tutorial', 'procreate lettering brushes', 'procreate tutorial lettering', 'lettering in procreate', 'procreate brush lettering', 'lettering brushes', 'how to add brushes to procreate', 'how to install procreate brushes', 'project based learning', 'learn', 'learning', 'course', 'online course', 'guide', 'class',
  ],
  motionMail: '',
  price: '197',
  salePrice: '147',
  paymentPlan:{
    price: '75',
    perMonth: '3 Payments of $75/m',
    savings: '12%'
  },
  onSale: false,
  tagline: 'Learn how to digitally paint, vectorize and reuse watercolor florals in Procreate',
  classDescriptor: 'Learn how to digitally paint, vectorize and reuse watercolor florals in Procreate',
  intro: {
    imgName: 'procreate301/tablet-intro.png',
    imgAlt: 'Welcome to 3d Lettering in Procreate',
    bullets: [
      {
        title: 'Beginner Friendly',
        desc:
          'Step-by-step narration with closeups on all the details, so you feel confident in the process from start to finish.',
      },
      {
        title: 'A Versatile Process',
        desc:
          'Since every lettering style is different, this process has been fine-tuned to fit any situation. You’ll be able to achieve a realistic watercolor effect when you apply it to any style - hand lettered or typed.',
      },
      {
        title: 'Blend Options',
        desc:
          'You may want an ombré, one color, smooth transitions blend with one of your pieces and a multi-colored blend with water pockets on another. This course serves up 5 different blend options, so you’ll have plenty to choose from when you begin your next lettering piece.',
      },
      {
        title: 'Florals + Foliage Integration',
        desc:
          'Take your watercolor lettering even further by integrating florals and foliage! A bonus florals foundations module is included, so even if you’ve never painted florals before, you’ll be able to follow along and complete every project in the class.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#bec1b0`,
        textColor: `#4a5457`,
        subheadColor: `#fff`,
        projectImg: `procreate301/project-1.jpg`,
        projectImgMobile: `procreate301/project-1.jpg`,
        type: '',
        desc:
          'The class kicks off with floral and foliage doodles in project one. These simple illustrations are perfect for social media icons and logos. Using only 1-2 brushes with limited color palettes, this is a project designed for even first time users of Procreate.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#a4a9a5`,
        textColor: `#fff`,
        subheadColor: `#e76d76`,
        projectImg: `procreate301/project-2.jpg`,
        projectImgMobile: `procreate301/project-2-mobile.jpg`,
        type: '',
        desc:
          'We loosen up the style in project 2 with a bouquet composed of easy to create wildflowers. We go over how to plan a balanced design using a sketch layer + reference images and talk about how to layer multiple elements for a full, but uncrowded feel.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#dacaca`,
        textColor: `#926f6b`,
        subheadColor: `#afc996`,
        projectImg: `procreate301/project-3.jpg`,
        projectImgMobile: `procreate301/project-3-mobile.jpg`,
        type: '',
        desc: 'If you have a favorite photo of florals or would like to practice realistic florals more in depth, this process is for you. In this project, you’ll learn how to use a photo as a template to create an illustrated watercolor version, with color and elements directly influencing the reproduction.',
      },
      {
        title: 'Project 4',
        type: '',
        projectImg: `procreate301/project-4.jpg`,
        projectImgMobile: `procreate301/project-4-mobile.jpg`,
        backgroundColor: `#c7d0da`,
        textColor: `#565857`,
        subheadColor: `#f0f0f0`,
        desc:
          'Project 4 kicks off the container series with a frosted glass, water-filled vase and a simple bouquet. Build on skills from project 1 for a more advanced, wet on dry result.',
      },
      {
        title: 'Project 5',
        type: '',
        projectImg: `procreate301/project-5.jpg`,
        projectImgMobile: `procreate301/project-5-mobile.jpg`,
        backgroundColor: `#c0c1bc`,
        textColor: `#ffffff`,
        subheadColor: `#419187`,
        desc:
          'Create overgrown potted daisies in project 5! We start by creating a custom sketch template, paint over it and add in extra depth utilizing blend modes and clipping masks. Next, we use a combination of wet on wet petals with wet on dry foliage for our most complex piece yet.',
      },
      {
        title: 'Project 6',
        type: '',
        projectImg: `procreate301/project-6.jpg`,
        projectImgMobile: `procreate301/project-6-mobile.jpg`,
        backgroundColor: `#f3f0eb`,
        textColor: `#566572`,
        subheadColor: `#be8d87`,
        desc:
          'In Project 6, we use the wet on wet technique to create a sense of depth by creating variations of soft focus amongst our lavender. Wet on dry grasses envelope the florals for an organized, but organic + complete feel.',
      },
      {
        title: 'Project 7',
        type: '',
        projectImg: `procreate301/project-7.jpg`,
        projectImgMobile: `procreate301/project-7-mobile.jpg`,
        backgroundColor: `#566572`,
        textColor: `#f3f0eb`,
        subheadColor: `#be8d87`,
        desc:
          'We finish up the container series with a pitcher full of forget me nots in project 7. Once again, we use a combination of wet on wet and wet on dry techniques, but also integrate stackable clipping masks, layer symmetry and multiple blend modes.',
      },
      {
        title: 'Project 8',
        type: '',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#dcdace`,
        textColor: `#4f4f4f`,
        subheadColor: `#544143`,
        desc:
          'Project 8 is a combination of felt floral shape inspiration and custom general florals for a whimsical, abundant feel. We freehand our arrangement as florals are painted, recolored and manipulated, using only a single line guide and one reference image. We finish everything off with some custom lettering and simple branch details.',
      },
      {
        title: 'Project 9',
        type: '',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#9aa8a4`,
        textColor: `#f5f5f4`,
        subheadColor: `#544143`,
        desc:
          'In our most complex class arrangement, we create a custom sketch template that starts with a single line and a centerpoint. Blooming florals are added in, complete with wet on wet and wet on dry details. We utilize multiple styles of florals and foliage to support our main focal point and create artwork that can be reused on any piece of stationery or social media graphics.',
      },
      {
        title: 'Project 10',
        type: '',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#82595d`,
        textColor: `#f5f5f4`,
        subheadColor: `#544143`,
        desc:
          'We finish the course with a seamless, repeatable watercolor floral pattern! Making precise adjustments and completing specific steps in the process, we create a pattern tile that can be reused in Procreate and defined as a swatch in Illustrator or a layer style pattern in Photoshop. Full creation and reusage options (Procreate, Illustrator + Photoshop) are shared.',
      },
    ],
    advanced: [],
  },
  curriculum: [
    {
      title: 'Welcome + Bonuses',
      videos: [
        {
          title: 'What You\'ll Learn/Class Overview',
          duration: '7:36',
        },
        {
          title: 'Bonuses Location + Install Instructions',
          duration: '5:20',
        },
        {
          title: 'Tips About File Size',
          duration: '6:49',
        },
        {
          title: 'Watercolor Illustration Brushes Overview',
          duration: '6:59',
        },
      ],
    },
    {
      title: 'Digital Watercolor Methods + Techniques',
      videos: [
        {
          title: 'Wet on Wet',
          duration: '6:06',
        },
        {
          title: 'Wet on Dry',
          duration: '2:11',
        },
        {
          title: 'Combination',
          duration: '3:22',
        },
        {
          title: 'Softening',
          duration: '3:48',
        },
      ],
    },
    {
      title: 'Leaves + Petals Practice',
      videos: [
        {
          title: 'Leaf Painting Practice: Common Shapes',
          duration: '3:04',
        },
        {
          title: 'Petal Painting Practice: Common Shapes',
          duration: '2:23',
        },
      ],
    },
    {
      title: 'Project 1: Simple Floral + Foliage Doodles',
      videos: [
        {
          title: 'Specific Floral Doodles',
          duration: '8:39',
        },
        {
          title: 'General Floral Doodles',
          duration: '8:41',
        },
        {
          title: 'General Foliage Doodles',
          duration: '8:56',
        },
      ],
    },
    {
      title: 'Project 2: Loose Wildflower Bouquet',
      videos: [
        {
          title: 'Balanced Bouquet Anatomy',
          duration: '6:23',
        },
        {
          title: 'Creating Your Bouquet\'s Composition Template',
          duration: '3:37',
        },
        {
          title: 'Painting Loose Wildflowers',
          duration: '8:36',
        },
        {
          title: 'Adding Foliage + Finishing Touches',
          duration: '10:54',
        },
      ],
    },
    {
      title: 'Project 3: Photo-Based Bouquet',
      videos: [
        {
          title: 'Setting Up Your File',
          duration: '5:40',
        },
        {
          title: 'Recreating Large Florals',
          duration: '7:50',
        },
        {
          title: 'Tri-Colored Rose',
          duration: '4:09',
        },
        {
          title: 'Berries + Daisies',
          duration: '5:52',
        },
        {
          title: 'Painting Foliage + Finalizing',
          duration: '6:15',
        },
      ],
    },
    {
      title: 'Project 4: [Containers] Floral Vase with Flowers',
      videos: [
        {
          title: 'Painting a Frosted Glass Vase',
          duration: '4:30',
        },
        {
          title: 'Planning + Painting Thistles + Foliage',
          duration: '3:09',
        },
        {
          title: 'Small Daisies + Final Foliage',
          duration: '4:44',
        },
      ],
    },
    {
      title: 'Project 5: [Containers] Potted Plant',
      videos: [
        {
          title: 'Sketching + Painting a Clay Pot',
          duration: '4:05',
        },
        {
          title: 'Adding Loose Potted Florals + Foliage',
          duration: '5:53',
        },
      ],
    },
    {
      title: 'Project 6: [Containers] Bucket of Lavender',
      videos: [
        {
          title: 'Sketching + Painting the Bucket',
          duration: '8:06',
        },
        {
          title: 'Painting Wet on Wet Lavender',
          duration: '6:27',
        },
        {
          title: 'Adding Grass + Finalizing',
          duration: '4:03',
        },
      ],
    },
    {
      title: 'Project 7: [Containers] Pitcher of Forget Me Nots',
      videos: [
        {
          title: 'Creating the Pitcher',
          duration: '7:18',
        },
        {
          title: 'Painting Forget Me Nots',
          duration: '8:08',
        },
        {
          title: 'Adding Grass + Finalizing',
          duration: '6:34',
        },
      ],
    },
    {
      title: 'Project 8: Floral Wreath',
      videos: [
        {
          title: 'File Prep for Painting',
          duration: '3:24',
        },
        {
          title: 'Painting Large Anemones',
          duration: '8:06',
        },
        {
          title: 'Painting Roses',
          duration: '4:18',
        },
        {
          title: 'Painting Supporting Florals',
          duration: '8:38',
        },
        {
          title: 'Foliage + Final Details',
          duration: '4:46',
        },
      ],
    },
    {
      title: 'Project 9: Floral Border Element',
      videos: [
        {
          title: 'Planning Your Element',
          duration: '4:54',
        },
        {
          title: 'Painting Large Florals',
          duration: '9:49',
        },
        {
          title: 'Painting Supporting Florals',
          duration: '5:22',
        },
        {
          title: 'Foliage + Final Details',
          duration: '5:15',
        },
      ],
    },
    {
      title: 'Project 10: Seamless Floral Pattern',
      videos: [
        {
          title: 'How the Pattern Tile Works + Creating Your Base Design',
          duration: '8:12',
        },
        {
          title: 'Vertical Alignment + Filling',
          duration: '6:24',
        },
        {
          title: 'Horizontal Alignment + Filling',
          duration: '4:02',
        },
        {
          title: 'Final Adjustments',
          duration: '3:13',
        },
        {
          title: 'How to Use Your Pattern Tile in Photoshop + Illustrator',
          duration: '3:55',
        },
      ],
    },
    {
      title: 'BONUS: Saving Art for Future Use',
      videos: [
        {
          title: 'Sharing, Saving + Inserting',
          duration: '3:28',
        },
      ],
    },
    {
      title: 'BONUS: Vectorizing Digital Florals',
      videos: [
        {
          title: 'File Prep for Vectorizing',
          duration: '5:01',
        },
        {
          title: 'Trace Settings, Vectorizing + Saving in Adobe Illustrator',
          duration: '8:15',
        },
      ],
    },
    {
      title: 'Thank You',
      videos: [
        {
          title: 'Thank You + Next Steps',
          duration: '0:57',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate301/bonus-title.png`,
    imgAlt: 'Watercolor lettering in Procreate Bonuses',
    gridType: 2,
    items: [
      {
        title: 'Watercolor Illustration Brush Set',
        desc: 'The full Procreate brush set (17 brushes!) are included with enrollment so you can follow along exactly. Brushes include wet on wet and wet on dry style brushes, as well as hard and soft bloom stamps, splatter brushes and paper pattern brushes to make your watercolor artwork as realistic as possible.  ',
        imgName: 'procreate401/bonus-1.jpg',
        imgAlt: 'Procreate Watercolor Lettering Brush Pack',
      },
      {
        title: 'Extended License of the brushes',
        desc: 'An extended license of the brush set ($30 value) is included, so you can create unlimited artwork now and in the future with full permissions to sell it.',
        imgName: 'procreate401/bonus-2.jpg',
        imgAlt: '4 Unique Watercolor Paper Textures',
      },
      {
        title: 'Vectorization Videos',
        desc: 'Learn best practices for exporting your Procreate artwork, adjusting color contrast in Photoshop and specific trace settings for vectorization in Adobe Illustrator. You’ll also learn how to efficiently clean up the trace and save it as an svg, ai and eps file.',
        imgName: 'procreate401/bonus-3.jpg',
        imgAlt: 'Color Swatches Files',
      },
      {
        title: 'How to save art for future use video',
        desc: 'When you create floral wreaths, bouquets and border elements, the possibility always exists to reuse those elements in future artwork and programs, or sell them as part of a graphics set. In this bonus video, you’ll learn how to prepare your file and export it for use in any program that permits inserted images.',
        imgName: 'procreate401/bonus-4.jpg',
        imgAlt: 'Color Swatches Files',
      },
      {
        title: 'Every project’s color palette as a download',
        desc: 'Install each color palette for every project so you can start working asap! These are the exact palettes seen and can be used for any future floral artwork, too!',
        imgName: 'procreate401/bonus-5.jpg',
        imgAlt: '8 Procreate Project Files',
      },
      {
        title: 'Every project’s original procreate file',
        desc: 'If you ever get stuck or would like to reference the full file for any project, all 10 projects files are available to you as free downloads.',
        imgName: 'procreate401/bonus-6.jpg',
        imgAlt: '8 Procreate Project Files',
      },
    ],
  },
  courseCard: {
    title: 'Lettering in Procreate',
    backgroundImgName: ``,
    backgroundColor: '#65807c',
    cardImgName: `procreate301/watercolor-class-card-4.jpg`,
    desc: 'Create beautiful and realistic watercolor lettering in Procreate! Learn versatile blending options, several texturing options and final details to bring your digital watercolor artwork to life. Created with beginners in mind, every step is described in detail, with clear control close ups and repetition for easy learning. This project based course makes learning fun with 8 unique projects to up your social media game at the same time. Get a bonus dose of inspiration and artwork options with florals and foliage foundations, so you’ll be able to create the stunning digital watercolor lettering compositions you’ve always wanted.',
    bullets: [
      'Access to 33 HD step-by-step videos',
      'Every project’s color palette',
      '8 unique watercolor lettering projects',
      'Bonus Florals + Foliage Foundations module',
      'Complete Procreate Watercolor Lettering Brush Pack (8 custom brushes)',
      'Extended license of the Procreate Watercolor Lettering Brush Pack',
      '4 unique watercolor paper textures',
      'Every project’s fully layered original Procreate file',
      'Unlimited updates',
      'Lifetime access to the class',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `sell-card-pencil-reflection-light.png`,
      },
    },
    priceColor: `#ED856A`,
    saleColor: `#ED856A`,
    stats: {
      modules: `#cc836f`,
      videos: `#758384`,
      hours: `#a79e8d`,
    },
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: 'Yep! If you finish the course and feel you haven’t learned anything new, email me within 14 days of purchase for a full refund.',
    },
    {
      question: 'How long can I access the course for?',
      answer: 'Forever! As long as Every Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: 'This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.',
    },
    {
      question: 'What will I need to take this class?',
      answer: 'You’ll need the Procreate app (v. 5.0.1 or newer), a pressure sensitive iPad (see this list: every-tuesday.com/ipads) and a stylus compatible with that iPad (I recommend an Apple Pencil).',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?',
      answer: 'Yes, and they’re all included for free with your enrollment. Refer to the course video titled ‘bonuses and install instructions’ for their location and a full installation tutorial.',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: 'The course on Skillshare is an intro version of the course that only includes the first 2 projects of this class. For a full comparison of the two versions, please view this chart: https://every-tuesday.com/florals-comparison',
    },
    {
      question: 'I’m still learning Procreate. Is this for me?',
      answer: 'Yep! The course was designed with beginners in mind, which is why it was built to increase in complexity as the course progresses. As long as you take the course in order, you’ll learn a lot about Procreate at a comfortable pace and be able to follow along through every project.',
    },
    {
      question: 'If I recreate these projects following your instruction, can I sell that artwork afterward?',
      answer: 'You may use any of the brushes, techniques or color palettes provided in the class to create your own unique artwork to sell. You may not sell recreated class projects, as they are my own original artwork + concepts.',
    },
  ],
  testimonials: [],
  letsDoThis: {
    imgName: 'procreate301/lets-do-this-2.jpg',
    altTag: 'Enroll in Watercolor Florals for Procreate today!',
    text: 'Welcome to Watercolor Florals in Procreate, your one stop for creating stunning + realistic digital watercolor florals',
  },
  sellCard: {
    priceColor: `#525f7f`,
    saleColor: '#6f8fcd',
    cardImg: 'procreate401/sell-card.jpg',
    saleLink: 'https://courses.every-tuesday.com/purchase?product_id=1962019',
    link: 'https://courses.every-tuesday.com/purchase?product_id=1962016',
    paymentPlanLink: 'https://courses.every-tuesday.com/purchase?product_id=1962017',
    customBtnBackgroundColor: `#525f7f`,
    h2Color: `#525f7f`,
    hoverColor: {
      h2: `#fff`,
      text: `#ED856A`,
      overlay: `#525f7f`,
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Extended license + full Procreate Watercolor Illustration Brush Set',
      'Tutorials for digital wet on wet + wet on dry techniques',
      'All original Procreate project files',
      'All project color swatches',
      'Bonus vectorization and future use videos',
      '14 day money back guarantee',
    ],
  },
}
export default course
